import React from 'react'
import PropTypes from "prop-types";
import entete from "../../../assets/img/entete.jpg"
import { frenchDateOnly } from '../../../variables/functions';
import { Table } from 'antd';
import { displayNumbers } from '../../../variables/numbersFunctions';
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import './BorderauReversementPrimes.css'; // Fichier CSS à créer

const BorderauReversementPrimes = React.forwardRef((props, ref) => {
    // Calcul des totaux
    const calculerTotaux = () => {
        const reglements = props?.bordereau?.reglements || [];
        return reglements.reduce((acc, record) => ({
            montant: acc.montant + (record.montant || 0),
            montantCompagnie: acc.montantCompagnie + (record.montantCompagnie || 0),
            accessoires: acc.accessoires + (record.accessoires || 0),
            taxes: acc.taxes + (record.taxes || 0),
            commission: acc.commission + (record.commission || 0),
        }), {
            montant: 0,
            montantCompagnie: 0,
            accessoires: 0,
            taxes: 0,
            commission: 0,
        });
    };

    const totaux = calculerTotaux();

    const MyFooter = () => {
        return (
            <div className="table-footer-totaux">
                <div className="row-totaux">
                    {/* Colonnes texte/vides fusionnées : 565px + quelques ajustements */}
                    <div className="cell-empty" style={{ width: '675px' }}>
                        <b>TOTAUX</b>
                    </div>
                    {/* PN Pool (80px) */}
                    <div className="cell-total" style={{ width: '70px' }}>
                        <b>{displayNumbers(totaux.montant)}</b>
                    </div>
                    {/* PN Cie (80px) */}
                    <div className="cell-total" style={{ width: '110px' }}>
                        <b>{displayNumbers(totaux.montantCompagnie)}</b>
                    </div>
                    {/* Accessoires (80px) */}
                    <div className="cell-total" style={{ width: '80px' }}>
                        <b>{displayNumbers(totaux.accessoires)}</b>
                    </div>
                    {/* Taxes (80px) */}
                    <div className="cell-total" style={{ width: '80px' }}>
                        <b>{displayNumbers(totaux.taxes)}</b>
                    </div>
                    {/* Taux (%) (80px) */}
                    <div className="cell-total" style={{ width: '80px' }}>
                        <b>-</b>
                    </div>
                    {/* Commission (90px) */}
                    <div className="cell-total" style={{ width: '90px' }}>
                        <b>{displayNumbers(totaux.commission)}</b>
                    </div>
                </div>
                <div className="total-general">
                    <b>Total primes</b>:{" "}
                    {displayNumbers(props?.bordereau?.montantTotal)} F CFA
                </div>
            </div>
        );
    };

    const columns = [
        {
            title: "Police",
            dataIndex: "numeroPoliceP",
            key: "numeroPoliceP",
            render: (_, record) => (
                <span>{record.contrat?.numeroPoliceM ? record.contrat?.numeroPoliceM : record.contrat?.numeroPoliceP}</span>
            ),
            width: 100
        },
        {
            title: "Avenant",
            dataIndex: "numeroPoliceP",
            key: "numeroPoliceP",
            render: (_, record) => (
                <span>{record?.avenantCode}</span>
            ),
            width: 70
        },
        {
            title: "Assuré",
            dataIndex: "assure",
            key: "assure",
            render: (_, record) => (
                <span>{record.contrat?.souscripteur?.nom} {record.contrat?.souscripteur?.prenom}</span>
            ),
            width: 150
        },
        {
            title: "Effet",
            dataIndex: "dateEffet",
            key: "dateEffet",
            render: (_, record) => (
                <span>{record?.contrat?.dateEffet ? frenchDateOnly(record?.contrat?.dateEffet) : "-"}</span>
            ),
            width: 80
        },
        {
            title: "Echéance",
            dataIndex: "dateEcheance",
            key: "dateEcheance",
            render: (_, record) => (
                <span>{record?.contrat?.dateEcheance ? frenchDateOnly(record?.contrat?.dateEcheance) : "-"}</span>
            ),
            width: 85
        },
        {
            title: "Catégorie",
            dataIndex: "categorie",
            key: "categorie",
            render: (_, record) => (
                <span>{record.contrat?.categorie}</span>
            ),
            width: 80
        },
        {
            title: "PN Pool",
            dataIndex: "primeNette",
            key: "primeNette",
            render: (_, record) => (
                <span style={{ textAlign: 'right', display: 'block' }}>{displayNumbers(record.montant)}</span>
            ),
            width: 80
        },
        {
            title: "PN Cie",
            dataIndex: "primeNetteCie",
            key: "primeNetteCie",
            render: (_, record) => (
                <span style={{ textAlign: 'right', display: 'block' }}>{displayNumbers(record.montantCompagnie || 0)}</span>
            ),
            width: 80
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
            render: (_, record) => (
                <span style={{ textAlign: 'right', display: 'block' }}>{displayNumbers(record?.accessoires || 0)}</span>
            ),
            width: 80
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
            render: (_, record) => (
                <span style={{ textAlign: 'right', display: 'block' }}>{displayNumbers(record.taxes || 0)}</span>
            ),
            width: 80
        },
        {
            title: "Taux (%)",
            dataIndex: "tauxCommissions",
            key: "tauxCommissions",
            render: (_, record) => (
                <span style={{ textAlign: 'right', display: 'block' }}>{displayNumbers(record.tauxCommission || 0)}</span>
            ),
            width: 80
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "commission",
            render: (_, record) => (
                <span style={{ textAlign: 'right', display: 'block' }}>{displayNumbers(record.commission || 0)}</span>
            ),
            width: 90
        },
    ];

    return (
        <div className="page-content">
            <Table
                className="bordereau-table"
                columns={columns}
                dataSource={props?.bordereau?.reglements}
                pagination={false}
                size='small'
                bordered
                footer={() => <MyFooter />}
            />
        </div>
    )
});

BorderauReversementPrimes.propTypes = {
    bordereau: PropTypes.object,
    agence: PropTypes.object,
}

export default BorderauReversementPrimes